import { ListItemText, Stack, Typography } from "@mui/material";

export default function Concepts() {
  return (
    <Stack bgcolor="#F4F8FF" p={8} spacing={5}>
      <Stack alignItems="center" spacing={3} mt={8}>
        <Typography color="#20487E" variant="h3" fontWeight="bold">
          Onze concepten
        </Typography>

        <Typography width={720} fontSize="18px" textAlign="center" color="#888">
          Aan de hand van de inzichten uit ons onderzoek, hebben wij ontwerprichtlijnen opgesteld.
          Deze richtlijnen helpen ons bij het verzinnen van een passend concept voor ons
          ontwerpdoel.
        </Typography>
      </Stack>

      <Stack direction="row" justifyContent="center" spacing={3}>
        <Stack width="320px" bgcolor="#FFF" sx={{ borderRadius: "25px" }}>
          <img src={require("../Assets/Images/concept1.webp")} alt="" />

          <Stack spacing={3} px={5} py={3}>
            <Typography variant="h5" fontWeight="bold">
              Veilig is 'n feestje
            </Typography>

            <Typography fontSize={16} color="#888">
              Brandveiligheidsgear als party props. Bijvoorbeeld een rookmelder die ook gebruikt kan
              worden als party lamp en speaker.
            </Typography>

            <ul>
              <li style={{ color: "#888" }}>
                <ListItemText
                  primary="De 'cool' factor trekt aandacht bij de doelgroep"
                  sx={{ color: "#888" }}
                />
              </li>

              <li style={{ color: "#888" }}>
                <ListItemText
                  primary="Bevordert brandveiligheid in studentenhuizen"
                  sx={{ color: "#888" }}
                />
              </li>
            </ul>
          </Stack>
        </Stack>

        <Stack width="320px" bgcolor="#FFF" sx={{ borderRadius: "25px" }}>
          <img src={require("../Assets/Images/concept2.webp")} alt="" />

          <Stack spacing={3} px={5} py={3}>
            <Typography variant="h5" fontWeight="bold">
              Strijd je slim
            </Typography>

            <Typography fontSize={16} color="#888">
              Een digitale applicatie waarin studenten met elkaar strijden.
            </Typography>

            <ul>
              <li style={{ color: "#888" }}>
                <ListItemText
                  primary="Na het beantwoorden van vragen over brandveiligheid in jouw studentenhuis krijg je een score"
                  sx={{ color: "#888" }}
                />
              </li>

              <li style={{ color: "#888" }}>
                <ListItemText
                  primary="Denk hierbij aan het bouwjaar, aanwezigheid van brandblussers en branddekens"
                  sx={{ color: "#888" }}
                />
              </li>
            </ul>
          </Stack>
        </Stack>

        <Stack width="320px" bgcolor="#FFF" sx={{ borderRadius: "25px" }}>
          <img src={require("../Assets/Images/concept3.webp")} alt="" />

          <Stack spacing={3} px={5} py={3}>
            <Typography variant="h5" fontWeight="bold">
              Maak het veilig
            </Typography>

            <Typography fontSize={16} color="#888">
              Een online spel waarin de doelgroep hun huis zo brandveilig mogelijk moeten maken door
              opdrachtjes te doen.
            </Typography>

            <ul>
              <li style={{ color: "#888" }}>
                <ListItemText
                  primary="Dit spel kan via de browser gespeeld worden"
                  sx={{ color: "#888" }}
                />
              </li>

              <li style={{ color: "#888" }}>
                <ListItemText
                  primary="Als ze klaar denken te zijn klik je verder en kan je bekijken hoe goed je dit hebt gedaan"
                  sx={{ color: "#888" }}
                />
              </li>
            </ul>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}
